import { render, staticRenderFns } from "./error403-view.vue?vue&type=template&id=dea1195c&"
import script from "./error403-view.vue?vue&type=script&lang=ts&"
export * from "./error403-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports